//#region types
import { MessageGroupProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { FileUploaderProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import {
  Description,
  FileUploader,
  HorizontalFormField,
  TextAreaInput,
  GroupSection,
} from "components/common/wintForms";
import { CircularProgress } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function MessageGroup({ connect, pendingAttachments = 0 }: MessageGroupProps) {
  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.MessagesAndAttachments)}
      icon={IconDefinitionConstants.WCommentDots}
    >
      <HorizontalFormField<TextInputProps>
        Component={TextAreaInput}
        {...connect("otherSettings.notes")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Message)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.MessageDescription)}
        optional
      />
      <HorizontalFormField<FileUploaderProps>
        Component={FileUploader}
        {...connect("otherSettings.attachments")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Attachments)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.AttachmentsDescription)}
      >
        {pendingAttachments > 0 && (
          <div className={cssExports.forwardedCostAttachmentFetching}>
            <CircularProgress size={16} thickness={6} />
            <Description horizontal>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.FetchingAttachments)}
            </Description>
          </div>
        )}
      </HorizontalFormField>
    </GroupSection>
  );
}

export default MessageGroup;
